import React from 'react'

import {UseCase} from '@/sections/use-case'

import type {UseCaseFragment} from '@/graphql-types'

interface Props {
    slice: UseCaseFragment
}

export const UseCaseSlice = React.forwardRef<HTMLDivElement, Props>(
    ({slice: {primary, items}}, ref) => {
        return (
            <UseCase
                ref={ref}
                title={primary.title}
                titleAs="h1"
                subtitle={primary.subtitle}
                cta={primary.cta}
                secondaryCtaLabel={primary.secondary_cta_label}
                secondaryCtaLink={primary.secondary_cta_link}
                items={items.map((item) => ({...item, icon: item.icon.fluid.base64}))}
            />
        )
    },
)
